<template>
    <div>
        <sau-template :retrieved="gotData">
            <!-- Fetching Placeholder -->
            <template slot="message">Fetching Domain Names</template>

            <!-- Data -->
            <template slot="data">
                <div class="row" v-if="Object.keys(domains).length > 0">
                    <div class="col pb-4 mb-4">
                        <a
                            href="/order/domain"
                            class="btn btn-success float-lg-right mt-1"
                        >
                            <i class="fas fa-plus"></i> Order New Domain
                        </a>
                        <a
                            href="/order/domain/transfer"
                            class="btn btn-primary float-lg-right mt-1 mr-1"
                        >
                            <i class="fas fa-arrow-right"></i> Transfer Domain
                        </a>
                    </div>
                </div>
                <table
                    v-if="Object.keys(domains).length > 0"
                    id="data-table-domains"
                    class="table table-hover data-table"
                    data-search="Search"
                    cellspacing="0"
                    width="100%"
                >
                    <thead class="d-none">
                        <tr>
                            <th>Name</th>
                            <th class="noshow">Expiry Date</th>
                            <th class="noshow">Registration Date</th>
                            <th class="noshow">Registration Period</th>
                            <th class="noshow">Status</th>
                            <th class="noshow">Auto Renew</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="domain in domains" :key="domain.id">
                            <td>
                                <a :href="domainLink(domain)">
                                    <div class="d-flex product-list">
                                        <div class="text-center p-2">
                                            <i
                                                class="product-icons pr-6 pt-2 icon-sau-domains"
                                                aria-hidden="true"
                                            ></i>
                                        </div>
                                        <div class="p-2">
                                            <p class="product-name">{{ domain.domainname }}</p>
                                            <p class="product-desc">
                                                <span class="sau-font-bold">Expiry Date:</span>
                                                {{ domain.expirydate | moment('DD/MM/YYYY') }}
                                            </p>
                                            <!-- <p class="product-desc"><span class="sau-font-bold">Registration Date:</span> {{ domain.regdate | moment('DD/MM/YYYY') }}</p> -->
                                            <!-- <p class="product-desc"><span class="sau-font-bold">Registration Period:</span> {{ domain.regperiod }} {{ domain.regperiod > 1 ? 'years' : 'year' }}</p> -->
                                            <p class="product-desc">
                                                <span class="sau-font-bold">Status:</span>
                                                <span
                                                    :class="statusClass(domain.status)"
                                                >{{ domain.status }}</span>
                                            </p>
                                            <p class="product-desc">
                                                <span class="sau-font-bold">Auto Renew:</span>
                                                <span
                                                    :class="renewClass(domain.donotrenew)"
                                                >{{ autorenewText(domain.donotrenew) }}</span>
                                            </p>
                                        </div>
                                    </div>
                                </a>
                            </td>
                            <td :data-filter="applyFilter('expiry-date', domain.expirydate)">
                                <p
                                    class="product-desc"
                                >{{ domain.expirydate | moment('DD/MM/YYYY') }}</p>
                            </td>
                            <td :data-filter="applyFilter('registration-date', domain.regdate)">
                                <p class="product-desc">{{ domain.regdate | moment('DD/MM/YYYY') }}</p>
                            </td>
                            <td :data-filter="applyFilter('registration-period', domain.regperiod)">
                                <p
                                    class="product-desc"
                                >{{ domain.regperiod }} {{ domain.regperiod > 1 ? 'years' : 'year' }}</p>
                            </td>
                            <td :data-filter="applyFilter('status', domain.status)">
                                <p class="product-desc">{{ domain.status }}</p>
                            </td>
                            <td
                                :data-filter="applyFilter('auto-renew', autorenewText(domain.donotrenew))"
                            >
                                <p class="product-desc">{{ autorenewText(domain.donotrenew) }}</p>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div v-else-if="notAuthorised">
                    <sau-request-permission></sau-request-permission>
                </div>

                <div v-else class="sau-bx text-center">
                    <div class="row p-2">
                        <div class="col">
                            <img src="/img/illustrations/domains.svg" width="190" class="mx-auto">
                            <h4>You don't have any active domains at the moment</h4>
                            <p>Register your new domain name instantly with Australia's largest independent accredited registrar with 24/7 local support.</p>
                        </div>
                    </div>

                    <div class="row px-12 pb-6">
                        <div class="col-sm-12 col-xl-4 bdr-rt bdr-1">
                            <div class="d-flex flex-column align-items-center p-4 h-100">
                                <h3 class="sau-pm-reset">.com</h3>
                                <div class="mb-auto clearfix">
                                    <div class="text-center">
                                        <hr>
                                        <p class="sau-font xs sau-para-m">From</p>
                                        <h2>$ 18.00</h2>
                                        <p class="sau-font xs sau-minus-m">Per Year</p>
                                        <hr>
                                        <div class="d-flex align-items-stretch">
                                            <p
                                                class="sau-font sm text-center"
                                            >International domain for a global market</p>
                                        </div>
                                    </div>
                                </div>

                                <a
                                    href="/order/domain"
                                    class="btn btn-success btn-sm text-center mb-6 w-75"
                                >Buy Now</a>
                            </div>
                        </div>
                        <div class="col-sm-12 col-xl-4 bdr-rt bdr-1">
                            <div class="d-flex flex-column align-items-center p-4 h-100">
                                <h3 class="sau-pm-reset">.com.au</h3>
                                <div class="mb-auto clearfix">
                                    <div class="text-center">
                                        <hr>
                                        <p class="sau-font xs sau-para-m">From</p>
                                        <h2>$ 28.00</h2>
                                        <p class="sau-font xs sau-minus-m">Per Year</p>
                                        <hr>
                                        <div class="d-flex align-items-stretch">
                                            <p
                                                class="sau-font sm text-center"
                                            >Great for Australian businesses</p>
                                        </div>
                                    </div>
                                </div>

                                <a
                                    href="/order/domain"
                                    class="btn btn-success btn-sm text-center mb-6 w-75"
                                >Buy Now</a>
                            </div>
                        </div>
                        <div class="col-sm-12 col-xl-4 bdr-rt bdr-1">
                            <div class="d-flex flex-column align-items-center p-4 h-100">
                                <h3 class="sau-pm-reset">.net</h3>
                                <div class="mb-auto clearfix">
                                    <div class="text-center">
                                        <hr>
                                        <p class="sau-font xs sau-para-m">From</p>
                                        <h2>$ 22.00</h2>
                                        <p class="sau-font xs sau-minus-m">Per Year</p>
                                        <hr>
                                        <div class="d-flex align-items-stretch">
                                            <p
                                                class="sau-font sm text-center"
                                            >Worldwide recognition for a global stage</p>
                                        </div>
                                    </div>
                                </div>

                                <a
                                    href="/order/domain"
                                    class="btn btn-success btn-sm text-center mb-6 w-75"
                                >Buy Now</a>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </sau-template>
    </div>
</template>
<script>
import jsFunctions from '@js/store/jqueryFunctions';
export default {
    mixins: [jsFunctions],
    data() {
        return {
            domains: '',
            notAuthorised: false
        };
    },
    created() {
        this.startApp();
    },
    methods: {
        startApp() {
            this.getDomains('/api/domains/')
                .then(response => {
                    if (response.data.data) {
                        this.domains = response.data.data;
                        this.$nextTick(() => {
                            this.initializeDataTables();
                        });
                    }
                })
                .catch(error => {
                    this.notAuthorised = true;
                });
        },
        autorenewText(autorenew) {
            return autorenew == 1 ? 'Off' : 'On';
        },
        domainLink(domain) {
            return `/service/domains/${domain.id}/details`;
        },
        renewClass(autorenew) {
            return autorenew == 1 ? 'text-danger' : 'text-success';
        },
        statusClass(status) {
            return status.toLowerCase() == 'active'
                ? 'text-success'
                : 'text-danger';
        }
    }
};
</script>
<style>
#data-table-domains a {
    color: #666;
    text-decoration: none;
}
</style>
